import axios from 'axios'
import server from '@/utils/server'
const state = {
    carNumber: 1, // 是否可以重复点击粘贴图片的按钮 1：不可重复点击 >1:放开这个限制  【当页面刷新之后重置为1】
    isViewModalOver: false, // 判断viewmodal是否全部渲染完成
    requestData: null // 请求数据 用来做前进后退的中间存储桥梁 衔接起来
    // isReturnRequest: false // 判断是否再次点击
}
const getters = {
    getcarNumber: state => {
        return state.carNumber;
    },
    getViewModalOver: state => {
        return state.isViewModalOver;
    },
    getRequestData: state => {
        //vvip不完全是单页应用, 要用localstorage兜底
        if (state.requestData) return state.requestData;
        return JSON.parse(localStorage.getItem("requestData"));
    }
    // getReturnRequest: state => {
    //     return state.isReturnRequest;
    // }
}
const mutations = {
    SET_CARNUMBER(state, data) {
        state.carNumber = data
    },
    SET_VIEWMODALOVER(state, data) {
        state.isViewModalOver = data
    },
    SET_REQUESTDATA(state, data) {
        //vvip不完全是单页应用, 要用localstorage兜底
        localStorage.setItem("requestData", JSON.stringify(data));
        state.requestData = data
    },
    // SET_RRTUENREQUEST(state, data) {
    //     state.isReturnRequest = data
    // }
}
const actions = {
    /** 
     * 获取扫码记录
     * **/
    LoginByUserTicket({
        context
    }, data) {
        return new Promise((reslove, reject) => {
            server.myAxios("/api/UserCenter/LoginByUserTicket", data).then(res => {
                reslove(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
     /** 
     * 获取滑块验证图片
     * **/
    GetSliderVerificationCode({
        context
    }, data) {
        return new Promise((reslove, reject) => {
            server.myAxios("/api/SliderVerification/GetSliderVerificationCode", data).then(res => {
                reslove(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    /** 
     * 进行滑块验证
     * **/
    ValidationSliderVerificationCode({
        context
    }, data) {
        return new Promise((reslove, reject) => {
            server.myAxios("/api/SliderVerification/ValidationSliderVerificationCode", data).then(res => {
                reslove(res)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}